import Vue from 'vue';
import VueRouter from 'vue-router';
import share from '~/views/share.vue';
import launch from '~/views/launch.vue';
import mobile from '~/views/mobile.vue'
import {isMobile} from '~/tools/utils'

Vue.use(VueRouter);

const router = new VueRouter({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {path: '/', redirect: 'index'},
    {
      path: '/index',
      component: mobile
    },
    {
      path: '/share',
      component: share
    },
    {
      path: '/launch',
      component: launch
    }
  ]
});

/**
 * 每次路由跳转是判断，是否解析了 微信配置需要参数
 * 若未获取则获取一次
 */
router.beforeEach((to, from, next) => {
  // console.log(to, from, next);
  next()
});
// router.afterEach((to, from) => {
//   console.log(to, from, 'after', store);
//   if (Object.keys(from.query).length){
//     let {openid,sceneId} = from.query;
//     to.query = { openid, sceneId}
//   }
// })

export default router;
